import { render, staticRenderFns } from "./TaskM.vue?vue&type=template&id=5b1f531c&scoped=true"
import script from "./TaskM.vue?vue&type=script&lang=ts"
export * from "./TaskM.vue?vue&type=script&lang=ts"
import style0 from "./TaskM.vue?vue&type=style&index=0&id=5b1f531c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f531c",
  null
  
)

export default component.exports